import { useSelector } from 'react-redux'

const usePermissions = () => {
  const profileRes = useSelector((state) => state.users_data.getMyProfile)
  const userProfile = profileRes?.data?.item
  const isProfileLoaded = profileRes?.status === 'success'

  const uiPermissions = userProfile?.role?.uiPermissions || []
  const userFacilities = userProfile?.facilities || []
  const isHQ = userFacilities.length === 0

  const hasPermission = (key) => uiPermissions.includes(key)

  const hasAnyPermission = (keys) => keys.some((key) => uiPermissions.includes(key))

  return { hasPermission, hasAnyPermission, userFacilities, isHQ, isProfileLoaded, uiPermissions }
}

export default usePermissions
